(() => {
  const modal = document.getElementById('image-modal');
  if (!modal) return;

  const closeBtn = modal.querySelector('.close');
  let lightboxSwiper;

  const productImages = Array.from(
    document.querySelectorAll('.product__media img')
  );

  productImages.forEach((img, index) => {
    img.addEventListener('click', () => {
      modal.style.display = 'block';
      document.body.classList.add('lightbox-open');

      if (!lightboxSwiper) {
        lightboxSwiper = new Swiper('.lightbox-swiper', {
          loop: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          on: {
            slideChange: resetZoom
          }
        });

        enableImageZoom();
      }

      lightboxSwiper.slideTo(index, 0);
    });
  });

  closeBtn.addEventListener('click', closeModal);

  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.style.display === 'block') {
      closeModal();
    }
  });

  function closeModal() {
    modal.style.display = 'none';
    document.body.classList.remove('lightbox-open');
    resetZoom();
  }

  function resetZoom() {
    modal.querySelectorAll('.lightbox-swiper img').forEach(img => {
      img.classList.remove('zoomed');
      img.style.transformOrigin = 'center center';
    });
  }

  function enableImageZoom() {
    modal.querySelectorAll('.lightbox-swiper img').forEach(img => {
      img.addEventListener('click', (e) => {
        e.stopPropagation(); // don’t close modal

        if (!img.classList.contains('zoomed')) {
          const rect = img.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;

          img.style.transformOrigin = `${x}% ${y}%`;
          img.classList.add('zoomed');
        } else {
          img.classList.remove('zoomed');
          img.style.transformOrigin = 'center center';
        }
      });
    });
  }
})();
